module.exports = __webpack_public_path__ + "img/kv3.b8c8163f.png";